import React from 'react';
import { formatearMonto } from '../../api/portalEstudiantes';
import styles from '../../styles/PortalEstudiantesStyles/PortalEstudiantes.module.css';

/**
 * Modal de pago exitoso
 * Muestra confirmación de que el pago fue registrado (pendiente de validación)
 * 
 * @param {Object} pago - Datos del pago (folio_recibo, monto, fecha, estado)
 * @param {Function} onClose - Callback al cerrar
 */
function PagoExitosoModal({ pago, onClose }) {
  const montoPagado = pago?.monto || 0;
  const fechaPago = pago?.fecha || new Date().toLocaleDateString('es-MX', { 
    day: '2-digit', 
    month: '2-digit', 
    year: 'numeric' 
  });
  const folioOperacion = pago?.folio_recibo || 'N/A';
  const estadoPago = pago?.estado || 'PENDIENTE_VALIDAR';

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={`${styles.modalHeader} ${styles.successHeader}`}>
          <div className={styles.successIcon}>✓</div>
          <h3 className={styles.modalTitle}>Pago registrado con éxito</h3>
        </div>

        <div className={styles.modalBody}>
          <p className={styles.successMessage}>
            Tu pago fue registrado correctamente y está pendiente de validación.
          </p>
          
          <div className={styles.pagoDetalles}>
            <div className={styles.detalleRow}>
              <span className={styles.detalleLabel}>Monto:</span>
              <span className={styles.detalleValue}>
                {formatearMonto(montoPagado)}
              </span>
            </div>
            <div className={styles.detalleRow}>
              <span className={styles.detalleLabel}>Fecha de registro:</span>
              <span className={styles.detalleValue}>{fechaPago}</span>
            </div>
            <div className={styles.detalleSeparator} />
            <div className={styles.detalleRow}>
              <span className={styles.detalleLabel}>Folio:</span>
              <span className={styles.detalleValue}>{folioOperacion}</span>
            </div>
            <div className={styles.detalleRow}>
              <span className={styles.detalleLabel}>Estado:</span>
              <span className={`${styles.detalleValue} ${styles.estadoPendienteValidar}`}>
                {estadoPago === 'PENDIENTE_VALIDAR' ? 'Pendiente de Validación' : estadoPago}
              </span>
            </div>
          </div>

          <div className={styles.avisoValidacionContainer}>
            <span className={styles.avisoValidacionIcon}>⏳</span>
            <p className={styles.avisoValidacionText}>
              Un administrador revisará y validará tu pago. 
              Una vez aprobado, se reflejará en tu estado de cuenta.
            </p>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button 
            className={styles.closeButton}
            onClick={onClose}
          >
            CERRAR
          </button>
        </div>
      </div>
    </div>
  );
}

export default PagoExitosoModal;
